import { render } from "./ShowCategory.vue?vue&type=template&id=25c07875"
import script from "./ShowCategory.vue?vue&type=script&lang=js"
export * from "./ShowCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__